import { InfoIcon } from "~/icons";
import type { OrderDispatchOption } from "~/types";
import { Box } from "../Box/Box";
import { SafeAreaBottom } from "../SafeArea/SafeArea";
import { Text } from "../Text/Text";

const textProps = {
  size: "large" as const,
  weight: "strong" as const,
  color: "neutral-100" as const,
};

export function OnlineStatusIndicator(props: {
  deliveryActive: boolean;
  pickupActive: boolean;
  serviceActive: boolean;
  dispatchOption: OrderDispatchOption | null;
  safeBottom?: boolean;
}): React.ReactNode | null {
  const { deliveryActive, pickupActive, dispatchOption, serviceActive } = props;

  let message: React.ReactNode;

  switch (dispatchOption) {
    case "DELIVERY":
      if (deliveryActive) {
        return null;
      }
      message = <WarningMessage keyword="Delivery" />;
      break;

    case "PICK_UP":
      if (pickupActive) {
        return null;
      }
      message = <WarningMessage keyword="Pick Up" />;
      break;

    case "SERVICE":
      if (serviceActive) {
        return null;
      }
      message = <WarningMessage keyword="Table Service" />;
      break;

    default:
      return null;
  }

  if (!pickupActive && !deliveryActive && !serviceActive) {
    message = closeMessage;
  }

  return (
    <Box
      width="full"
      style={{ alignContent: "center" }}
      padding={"3"}
      background="neutral-800"
      justifyContent="center"
      flexDirection={"row"}
      display={"flex"}
    >
      <Text {...textProps}>
        <InfoIcon />
      </Text>
      <Box paddingLeft={"2"} />
      {message}
      {props.safeBottom && (
        <Box>
          <SafeAreaBottom />
        </Box>
      )}
    </Box>
  );
}

const closeMessage: React.ReactNode = (
  <Text {...textProps}>Currently not accepting orders</Text>
);

function WarningMessage(props: { keyword: string }) {
  return (
    <Text {...textProps}>
      {props.keyword} is currently unavailable. Please select one of the other
      options.
    </Text>
  );
}
